import { render, staticRenderFns } from "./auto-table.vue?vue&type=template&id=527848ca&scoped=true&"
import script from "./auto-table.vue?vue&type=script&lang=js&"
export * from "./auto-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527848ca",
  null
  
)

export default component.exports